import { render, staticRenderFns } from "./productSpecValues.vue?vue&type=template&id=5bd01f90&scoped=true&"
import script from "./productSpecValues.vue?vue&type=script&lang=js&"
export * from "./productSpecValues.vue?vue&type=script&lang=js&"
import style0 from "./productSpecValues.vue?vue&type=style&index=0&id=5bd01f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd01f90",
  null
  
)

export default component.exports